const html2canvas = import('html2canvas').then(module=>module.default);
export default html2canvas;